<template>
  <ProductBottleResponcive
    :title="tasting.bottleName"
    :ratingPath="this.tasting.id"
    :status="status"
    :image="tasting.tileImage"
    :bottleId="tasting.bottleId"
    :price="price"
    :rating="rating"
    :id="idBottle"
    :isTasting="true"
    :small="small"
    @click="openTasting"
  />
</template>

<script>
import get from 'lodash/get'
import { mapGetters } from 'vuex'

import VvMobileTasteTile from '@/components/common/VvMobileTasteTilee'
import ProductBottleResponcive from '@/components/shop/ProductBottleResponcive'
import shopMixin from '@/mixins/shop'

export default {
  name: 'TastingListItem',
  components: { VvMobileTasteTile, ProductBottleResponcive },
  mixins: [shopMixin],
  props: {
    id: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
    }
  },
  computed: {
    ...mapGetters({ getTastingById: 'getTastingById' }),

    tasting() {
      console.log(this.getTastingById(this.id))
      return this.getTastingById(this.id)
    },
    ratingpath() {
      return "tasting/" + this.tasting.id + "/rating"
    },
    status() {
      const status = get(this.$store, ['state', 'completion', 'tasting', this.id], null)
      return status
    },
    price() {
      for (let bottle of this.bottles) {
        const splitTitle = bottle.title.split('||')
        const title = splitTitle[0]
        if (title == this.tasting.bottleName) {
          return Number(bottle.variants[0].price)
        }
      }
    },
    rating() {
      const tmp = get(this.$store, ['state', 'completion', 'tasting', this.tasting.id], null)
      return (tmp && tmp['rating'] ? parseInt(tmp['rating']) : 0)
    },
    idBottle() {
      for (let bottle of this.bottles) {
        const splitTitle = bottle.title.split('||')
        const title = splitTitle[0]
        if (title == this.tasting.bottleName) {
          return bottle.id
        }
      }
    }
  },
  methods: {
    openTasting() {
      this.$router.push({ name: 'tasting-funnel', params: { tastingId: this.id } })
    }
  }
}
</script>